var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-tooltip',[_c('template',{slot:"title"},[_vm._v("\n    Show To Apps\n  ")]),_vm._v(" "),_c('a-button',{attrs:{"icon":"check","size":"small"},on:{"click":_vm.handleClick}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }